import React from "react";
import { inject, observer } from "mobx-react";
import {
  Button,
  Modal,
  Grid,
  Row,
  Col,
  Collapse,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import ListSearch from "../components/bucket/ListSearch";
import { notApplicableItems } from "../constants/constants-container";
import { CombinationItem } from "../components/detail/CombinationItem";
import toastService from "../services/ToastService";
import { IoIosLink } from "react-icons/io";
import { TfiNewWindow } from "react-icons/tfi";
import { Link } from "react-router-dom";

import "./EntityDetailsModal.scss";

@inject("detailViewStore", "exportImportStore", "popupStore", "previewStore")
@observer
export default class CombinationDetailsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      rootItems: null,
      title: "",
    };
    this.items = undefined;
    this.refType = undefined;
  }
  async componentDidMount() {
    const { details, popupStore } = this.props;
    const entityDetails = await popupStore.fetchEntityDetailsWithoutCallback(
      details.type,
      details.tid
    );

    this.items =
      entityDetails.item.navigationLookupResult.navigationLookupRootItem.items.filter(
        (item) => item.object.type === "CombinationItem"
      );
    const rootItemObject =
      entityDetails.item.navigationLookupResult.navigationLookupRootItem.object;
    this.setState({
      title: `${rootItemObject.name.substring(0, 50)}${
        rootItemObject.name.length > 50 ? "..." : ""
      } (${rootItemObject.code})`,
      rootItems: this.items,
    });
  }
  componentDidUpdate = async () => {
    const {
      fetchEntityDetails,
      initAdditionalQueryParams,
      setPrevTid,
      setPrevType,
      setCanRefresh,
      canRefresh,
      type,
      prevTid,
      tid,
    } = this.context;

    if (tid !== prevTid && type && tid && canRefresh) {
      initAdditionalQueryParams(type);
      fetchEntityDetails(type, tid);
      setCanRefresh(false);
      setPrevType(type);
      setPrevTid(tid);
    }
  };

  handleCollapse = () => {
    const { mapped } = this.props;
    if (!mapped) return;
    this.setState({
      open: !this.state.open,
    });
  };

  copySqlToClipboard = () => {
    this.hiddenCodeTextArea.select();
    document.execCommand("copy");
    toastService.func_notify("The Combination has been copied to clipboard.");
  };
  getUrlForCopy = () => {
    const urlParts = window.location.href.split("?");
    const urlParams = urlParts.length > 1 ? "?" + urlParts[1] : "";
    const objectLinkForCopy =
      this.context.getEntityData?.item?.objectLink !== null
        ? window.location.origin +
          this.context.getEntityData.item.objectLink +
          urlParams
        : window.location.href;

    return encodeURIComponent(objectLinkForCopy);
  };

  getUrlForOpen = () => {
    const { details } = this.props;
    let objectLinkForOpen = "/view/";
    objectLinkForOpen =
      details !== null
        ? objectLinkForOpen + details.type + "/" + details.tid
        : window.location.href;
    return objectLinkForOpen;
  };

  render() {
    const { mapped } = this.props;
    const { open, title } = this.state;
    const { fetchingDataStatus } = this.props.popupStore;
    const fetchingStatus =
      (!mapped && fetchingDataStatus.get("Cubes") === true) ||
      (mapped && fetchingDataStatus.get("Cube") === true);
    if ((!this.items || this.items?.length < 1) && !fetchingStatus) return null;

    const searchExpr =
      this.props.popupStore.getSearchMatrix["FilterInCombination"] || "";
    const filteredItems = this.items?.filter((item) => {
      if (!item.items) return false;

      const names = item.items.map((i) =>
        i.object.name ? i.object.name.toLowerCase() : ""
      );
      const codes = item.items.map((i) =>
        i.object.code ? i.object.code.toLowerCase() : ""
      );
      if (searchExpr) {
        return (
          (names.some((name) => name.includes(searchExpr.toLowerCase())) ||
            codes.some((code) => code.includes(searchExpr.toLowerCase()))) &&
          names.every((name) => !notApplicableItems.includes(name))
        );
      } else {
        return names.every((name) => !notApplicableItems.includes(name));
      }
    });

    const combinationItems =
      filteredItems &&
      filteredItems.reduce(function (result, item) {
        const member = item.items.find((x) => x.object.type === "Member");
        if (member) {
          const variable = item.items.find((x) => x.object.type === "Variable");
          variable.object.member = member.object;
          result.push(variable.object);
        }
        return result;
      }, []);

    const combinationItemsClipboard = {
      name: title,
      value: combinationItems,
    };

    return (
      <Modal
        show={true}
        onHide={this.props.onClose}
        dialogClassName="VariableDetailsModal related-types-list cube-structure-item"
      >
        <Modal.Header closeButton>
          <Modal.Title>{title} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="related-objects custom-panel">
            <div
              className="custom-panel-heading"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex" }}>
                <h4>
                  {mapped
                    ? `Mapped ${this.refType || ""} Combination Representation`
                    : "Combination Representation"}
                </h4>
                {fetchingStatus ? ( // "Cubes" because the PrdLink used for combinationItems is Cube -> check the PrdLink
                  <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  marginLeft: "auto",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {this.context !== this.props.detailViewStore && (
                  <OverlayTrigger
                    placement="left"
                    overlay={
                      <Popover id={"Goto-icon"}>{"Open this Tab"}</Popover>
                    }
                  >
                    <span
                      style={{
                        fontSize: "17px",
                        cursor: "pointer",

                        marginInline: "5px",
                      }}
                    >
                      <Link
                        style={{
                          color: "#333",
                        }}
                        to={this.getUrlForOpen()}
                        target="_blank"
                      >
                        <TfiNewWindow></TfiNewWindow>
                      </Link>
                    </span>
                  </OverlayTrigger>
                )}
                <OverlayTrigger
                  placement="left"
                  overlay={<Popover id={"copy-icon"}>{"Copy link"}</Popover>}
                >
                  <span
                    style={{
                      fontSize: "17px",
                      cursor: "pointer",
                      marginInline: "5px",
                      paddingTop: "1px",
                    }}
                  >
                    <IoIosLink
                      onClick={() => {
                        navigator.clipboard.writeText(this.getUrlForCopy());
                        toastService.func_notify("Link copied to clipboard");
                      }}
                    ></IoIosLink>
                  </span>
                </OverlayTrigger>
              </div>
              {mapped ? (
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleCollapse();
                  }}
                >
                  {open === true ? "hide" : "show"}
                </a>
              ) : null}
            </div>

            {!fetchingStatus ? ( // "Cubes" because the PrdLink used for combinationItems is Cube -> check the PrdLink
              <Collapse in={mapped === true ? open : true}>
                <div className="custom-panel-body related-types-list">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <ListSearch
                      searchMatrixKey={"FilterInCombination"}
                      placeholder={"Filter by Name or Code"}
                    />
                    <Button
                      bsClass="btn btn-default"
                      style={{ marginBottom: 10 }}
                      onClick={this.copySqlToClipboard}
                    >
                      Copy to Clipboard
                    </Button>
                    <textarea
                      className="hidden-code-textarea"
                      style={{ position: "absolute", left: "-99999px" }}
                      ref={(el) => {
                        this.hiddenCodeTextArea = el;
                      }}
                      value={JSON.stringify(combinationItemsClipboard)}
                      readOnly={true}
                    />
                  </div>
                  <Grid className="cube-structure-item" fluid={true}>
                    <Row>
                      <Col xs={6}>
                        <h5>
                          <b>Attributes</b>
                        </h5>
                      </Col>
                      <Col xs={6}>
                        <h5>
                          <b>With values restricted to</b>
                        </h5>
                      </Col>
                    </Row>
                  </Grid>
                  <div className="item-list-container large">
                    {filteredItems?.length
                      ? filteredItems.map((item, key) => (
                          <CombinationItem item={item} key={key} />
                        ))
                      : "Nothing found"}
                  </div>
                </div>
              </Collapse>
            ) : (
              ""
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
